<template>
    <vx-card :title='$t("Roles")'>
        <vs-table ref="table" v-model="selected" @selected="handleSelected" pagination :max-items="50" search :data="roles">

            <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

                <div class="flex flex-wrap-reverse items-center">
                    <vs-button v-if="$checkPermission(702)" type="border" color="success" icon-pack="feather" icon="icon-plus-circle" @click="addRolePrompt = true">{{$t("Add")}}</vs-button>
                </div>

                <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
                    <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                        <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ roles.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : roles.length }} of {{ roles.length }}</span>
                        <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                    </div>

                    <vs-dropdown-menu>

                        <vs-dropdown-item @click="itemsPerPage=10">
                            <span>10</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="itemsPerPage=20">
                            <span>20</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="itemsPerPage=50">
                            <span>50</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="itemsPerPage=100">
                            <span>100</span>
                        </vs-dropdown-item>
                    </vs-dropdown-menu>
                </vs-dropdown>
            </div>

            <template slot="thead">
                <vs-th sort-key="name">{{$t("Name")}}</vs-th>
            </template>

            <template slot-scope="{data}">
                <tbody>
                <vs-tr :data="tr" :key="index" v-for="(tr, index) in data">

                    <vs-td :data="data[index].name">
                        {{ data[index].name }}
                    </vs-td>

                </vs-tr>
                </tbody>
            </template>

        </vs-table>

        <vs-popup :title="$t('Add')" :active.sync="addRolePrompt">
            <div>
                <p class="mt-6">{{$t("Name")}}</p>
                <vs-input v-model="addName" style="width: 100%"></vs-input>
                <vs-divider icon-pack="feather" icon="icon-lock" position="center" color="danger"></vs-divider>
                <permissions ref="addPermissions" :permissions="[]" :disabled-permissions="[]"></permissions>
                <vs-divider color="danger"/>
                <vs-button color="success" icon-pack="feather" icon="icon-edit" type="border" class="mt-6; mr-1" @click="addRole">{{$t("Add")}}</vs-button>
            </div>
        </vs-popup>

        <vs-popup v-if="$checkPermission(702)" :title="$t('Edit')" :active.sync="editRolePrompt">
            <div>
                <p class="mt-6">{{$t("Name")}}</p>
                <vs-input v-model="editName" style="width: 100%"></vs-input>
                <vs-divider icon-pack="feather" icon="icon-lock" position="center" color="danger"></vs-divider>
                <permissions ref="editPermissions" :permissions="editPermissions" :disabled-permissions="[]"></permissions>
                <vs-divider color="danger"/>
                <vs-button style="float: left" color="success" icon-pack="feather" icon="icon-edit" type="border" class="mt-6; mr-1" @click="editRole">{{$t("Change")}}</vs-button>
                <vs-button style="float: right" type="border" color="danger" icon-pack="feather" icon="icon-trash-2" @click="removeRole">{{$t("Delete")}}</vs-button>
            </div>
        </vs-popup>
    </vx-card>
</template>
<script>

    import Permissions from "./Permissions";

    export default {
        components: {Permissions},
        component:{
            Permissions
        },
        data() {
            return {
                selected: {},
                roles: [],

                itemsPerPage: 20,
                isMounted: false,

                addRolePrompt: false,
                editRolePrompt: false,

                addName: '',

                editName: '',
                editPermissions: [],
            }
        },
        computed: {
            currentPage() {
                if(this.isMounted) {
                    return this.$refs.table.currentx
                }
                return 0
            },
        },
        methods: {
            handleSelected(tr) {
                this.editName = tr.name;
                this.editPermissions = tr.permissions;
                this.editRolePrompt = true;
            },
            updateRoles() {
                const thisIns = this;
                this.$http.get('/api/v1/group/')
                    .then(function (response) {
                        thisIns.roles = response.data;
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
            addRole() {
                const thisIns = this;
                this.$http.post('/api/v1/group/', {
                    name: thisIns.addName,
                    permissions: thisIns.$refs.addPermissions.permissionsArray
                }).then(function () {
                    thisIns.updateRoles();
                    thisIns.addRolePrompt = false;
                    thisIns.addName = "";
                }).catch(function (error) {
                    thisIns.addRolePrompt = false;
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error.response.data,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            editRole() {
                const thisIns = this;
                this.$http.put('/api/v1/group/' + this.selected.id, {
                    name: thisIns.editName,
                    permissions: thisIns.$refs.editPermissions.permissionsArray
                }).then(function () {
                    thisIns.updateRoles();
                    thisIns.editRolePrompt = false;
                }).catch(function (error) {
                    thisIns.editRolePrompt = false;
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error.response.data,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            removeRole() {
                const thisIns = this;
                this.$http.delete('/api/v1/group/' + this.selected.id)
                .then(function () {
                    thisIns.updateRoles();
                    thisIns.editRolePrompt = false;
                }).catch(function (error) {
                    thisIns.editRolePrompt = false;
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error.response.data,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            }
        },
        watch: {
            editRolePrompt: function () {
                if(!this.editRolePrompt){
                    this.selected = {}
                }
            }
        },
        created() {
            this.updateRoles()
        },
        mounted() {
            this.isMounted = true;
        },
        beforeRouteLeave (to, from, next) {
            if(this.addRolePrompt){
                this.addRolePrompt = false;
                next(false)
            }else if(this.editRolePrompt){
                this.editRolePrompt = false;
                next(false)
            }else{
                next()
            }
        }
    }
</script>
